var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29,
    rx: 5,
    fill: "#DEF7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83398 8.83336V12.375H10.2462M10.2462 12.375C10.7165 11.212 11.5593 10.2379 12.6425 9.60535C13.7258 8.97277 14.9884 8.71749 16.2323 8.8795C17.4763 9.04152 18.6313 9.61168 19.5165 10.5006C20.4016 11.3896 20.9668 12.5471 21.1234 13.7917M10.2462 12.375H13.3757M21.1673 20.1667V16.625H20.7558M20.7558 16.625C20.2849 17.7873 19.4418 18.7607 18.3587 19.3927C17.2755 20.0247 16.0133 20.2797 14.7697 20.1177C13.5261 19.9558 12.3714 19.386 11.4862 18.4977C10.601 17.6093 10.0354 16.4525 9.8779 15.2084M20.7558 16.625H17.6257",
    stroke: "#27AA85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.a27ee81be0fd3a4329bc45f0a240d6a5.svg";
export { ForwardRef as ReactComponent };